<div class="leads-card">
  <h2>{{ title }}</h2>
  <p>
    <ng-container *ngIf="!isLoading; else loader">
      <span>{{ totalLeads }}</span> From
      {{ dateRange?.startDate | date : "mediumDate" }} to
      {{ dateRange?.endDate | date : "mediumDate" }}
    </ng-container>
  </p>
</div>

<ng-template #loader>
  <app-skeleton width="180px" height="20px" margin="10px 0 0"></app-skeleton>
</ng-template>
